<template>
  <div class="asideContent">
    <el-aside width="collapse">
      <el-menu
        background-color="var(--aside-color)"
        :collapse="isCollapse"
        class="el-menu-vertical-demo"
        :default-active="currentMenu"
        :collapse-transition="true"
        router
      >
        <!-- 动态渲染菜单项 -->
        <!-- 移除 template 上的 key -->
        <template v-for="item in menuList" v-show="item.show">
          <!-- 有子菜单的项（二级目录） -->
          <el-submenu
            v-if="item.children && item.children.length > 0"
            v-show="item.show"
            :index="item.path"
            :key="'submenu-' + item.id"
          >
            <template #title>
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <template v-for="child in item.children">
              <!-- 二级菜单有子菜单（三级目录） -->
              <el-submenu
                v-if="child.children && child.children.length > 0"
                v-show="child.show"
                :key="'submenu2-' + child.id"
                :index="child.path"
              >
                <template #title>
                  <i :class="child.icon"></i>
                  <span>{{ child.title }}</span>
                </template>
                <el-menu-item
                  v-show="subChild.show"
                  v-for="subChild in child.children"
                  :key="'child2-' + subChild.id"
                  :index="subChild.path"
                  @click.native.stop="selectMenu(subChild)"
                >
                  <span>{{ subChild.title }}</span>
                </el-menu-item>
              </el-submenu>
              <!-- 二级菜单没有子菜单（直接是菜单项） -->
              <el-menu-item
                v-else
                v-show="child.show"
                :key="'child-' + child.id"
                :index="child.path"
                @click.native.stop="selectMenu(child)"
              >
                <i :class="child.icon"></i>
                <span>{{ child.title }}</span>
              </el-menu-item>
            </template>
          </el-submenu>
          <!-- 无子菜单的项（一级目录） -->
          <el-menu-item
            v-else
            v-show="item.show"
            :index="item.path"
            :key="'item-' + item.id"
            class="custom-menu-item" 
            @click.native.stop="handleMenu(item)"
          >
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
  </div>
</template>
<script>
import { getNotReadMessageApi } from "@/api/seek";
import { getSession } from "@/util/localStor";
export default {
  name: "index",
  data() {
    return {
      isCollapse: false,
      currentId: "",
      currentMenu: this.$route.path,
      showMenu: true,
      newList: [],
      color: "var(--theme-color)",
      menuVisible: false,
      roleList: [],
      menuList: [
        {
          title: "首页",
          path: "/index",
          icon: "el-icon-house",
          name: "homePage:get",
          id: 880,
          show: false,
        },
        {
          title: "问卷管理",
          path: "/questionnaire",
          icon: "el-icon-document",
          name: "questionnaire:get",
          id: 941,
          show: false,
        },
        {
          title: "售后数据",
          path: "/statis",
          icon: "el-icon-s-data",
          name: "statis:get",
          id: 927,
          show: false,
        },
        {
          title: "技术咨询管理",
          path: "4",
          icon: "el-icon-headset",
          id: 887,
          show: false,
          children: [
            {
              title: "咨询列表",
              path: "/seek",
              pathChild1: "/seek/detail",
              pathChild2: "",
              name: "consultList:get",
              id: 888,
              show: false,
            },
          ],
        },
        {
          title: "整车索赔单管理",
          path: "5",
          icon: "claimFormManage",
          id: 889,
          show: false,
          children: [
            {
              title: "三包索赔单据审核",
              path: "5-1",
              icon: "threeGuaranteesClaim",
              id: 911,
              show: false,
              children: [
                {
                  title: "预审-索赔单列表",
                  path: "/claimantList",
                  pathChild1: "/claimant/edit",
                  pathChild2: "/claimant/preDetail",
                  name: "preapprovalClaimStatementList:get",
                  id: 903,
                  show: false,
                },
                {
                  title: "正式-索赔单列表",
                  path: "/claimant",
                  pathChild1: "/claimant/detail",
                  pathChild2: "",
                  name: "claimStatementList:get",
                  id: 890,
                  show: false,
                },
                {
                  title: "责任确定",
                  path: "/claimResponsibilityConfirm",
                  pathChild1: "/claimant/claimResponsibilityConfirmDetail",
                  pathChild2: "",
                  name: "claimConfirmList:get",
                  id: 907,
                  show: false,
                },
              ],
            },
            {
              title: "索赔结算",
              path: "5-2",
              icon: "claimSettlement",
              id: 912,
              show: false,
              children: [
                {
                  title: "索赔单结算",
                  path: "/claimant/claimSettlementOne",
                  pathChild1: "",
                  pathChild2: "",
                  name: "claimSettlementOne:get",
                  id: 910,
                  show: false,
                },
                {
                  title: "结算",
                  path: "/claimSettlement",
                  pathChild1: "/claimant/claimSettlementDetailList",
                  pathChild2: "/claimant/claimSettlementDetail",
                  name: "claimSettlementList:get",
                  id: 908,
                  show: false,
                },
              ],
            },
            {
              title: "二次索赔转索",
              path: "5-3",
              icon: "secondaryClaim",
              id: 913,
              show: false,
              children: [
                {
                  title: "二赔金额确认",
                  path: "/secondCompensationFill",
                  pathChild1: "/claimant/secondCompensationFillDetail",
                  pathChild2: "",
                  name: "claimFillSecondList:get",
                  id: 909,
                  show: false,
                },
                {
                  title: "成本价维护",
                  path: "/costPriceMaintenance",
                  pathChild1: "",
                  pathChild2: "",
                  name: "costPrice:get",
                  id: 950,
                  show: false,
                },
                {
                  title: "费率维护",
                  path: "/claimRateMaintenance",
                  pathChild1: "",
                  pathChild2: "",
                  name: "claimRateMaintenance:get",
                  id: 951,
                  show: false,
                },
              ],
            },
            {
              title: "活动支持管理",
              path: "5-4",
              icon: "el-icon-s-help",
              id: 914,
              show: false,
              children: [
                {
                  title: "活动支持",
                  path: "/kd-activitySupport",
                  pathChild1: "",
                  pathChild2: "",
                  name: "carActivitySupportList:get",
                  id: 1911,
                  show: false,
                },
                {
                  title: "活动索赔",
                  path: "/kd-activityClaim",
                  pathChild1: "",
                  pathChild2: "",
                  name: "carActivityClaim:get",
                  id: 1912,
                  show: false,
                },
              ],
            },
            {
              title: "索赔设置",
              path: "5-5",
              icon: "el-icon-setting",
              id: 915,
              show: false,
              children: [
                {
                  title: "质保时间设置",
                  path: "/warrantyTimeConfig",
                  pathChild1: "",
                  pathChild2: "",
                  name: "warrantyTimeConfig:get",
                  id: 1920,
                  show: false,
                },
                {
                  title: "预授权设置",
                  path: "/car-activityPreAuthorization",
                  pathChild1: "",
                  pathChild2: "",
                  name: "carActivityPreAuthorization:get",
                  id: 1913,
                  show: false,
                },
                {
                  title: "索赔预设数据",
                  path: "/claimantPre",
                  pathChild1: "",
                  pathChild2: "",
                  name: "presetList:get",
                  id: 904,
                  show: false,
                },
              ],
            },
            {
              title: "索赔单统计",
              path: "/claimStatistics",
              pathChild1: "",
              pathChild2: "",
              name: "claimStatistics:get",
              id: 1914,
              show: false,
            },

          ],
        },
        {
          title: "KD索赔单管理",
          path: "6",
          icon: "claimFormManage",
          id: 1889,
          show: false,
          children: [
            {
              title: "预审-KD索赔单列表",
              path: "/kd-claimantList",
              pathChild1: "/kd-claimant/edit",
              pathChild2: "/kd-claimant/preDetail",
              name: "kdPreapprovalClaimStatementList:get",
              id: 1903,
              show: false,
            },
            {
              title: "正式-KD索赔单列表",
              path: "/kd-claimantIndex",
              pathChild1: "/kd-claimant/detail",
              pathChild2: "",
              name: "kdClaimStatementList:get",
              id: 1904,
              show: false,
            },
            {
              title: "责任确定",
              path: "/kd-claimResponsibilityConfirm",
              pathChild1: "/kd-claimant/claimResponsibilityConfirmDetail",
              pathChild2: "",
              name: "kdClaimConfirmList:get",
              id: 1907,
              show: false,
            },
            {
              title: "二赔金额确认",
              path: "/kd-secondCompensationFill",
              pathChild1: "/kd-claimant/secondCompensationFillDetail",
              pathChild2: "",
              name: "kdClaimFillSecondList:get",
              id: 1909,
              show: false,
            },
            {
              title: "结算",
              path: "/kd-claimSettlement",
              pathChild1: "/kd-claimant/claimSettlementDetailList",
              pathChild2: "/kd-claimant/claimSettlementDetail",
              name: "kdClaimSettlementList:get",
              id: 1908,
              show: false,
            },
            {
              title: "KD索赔预设数据",
              path: "/kd-claimantPre",
              pathChild1: "",
              pathChild2: "",
              name: "kdPresetList:get",
              id: 1910,
              show: false,
            },
          ],
        },
        {
          title: "整车质量反馈管理",
          path: "7",
          icon: "qualityFeedbackManage",
          id: 897,
          show: false,
          children: [
            // {
            //   title: "质量问题反馈",
            //   path: "/quality",
            //   pathChild1: "/quality/detail",
            //   pathChild2: "",
            //   name: "carQualityFeedback:get",
            //   id: 898,
            //   show: false
            // },
            {
              title: "质量问题反馈",
              path: "/addFeedback",
              pathChild1: "/addFeedback/preSalesDetail",
              pathChild2: "/addFeedback/afterSalesDetail",
              pathChild3: "/problemDetailNew/Activity_0ss6860",
              name: "carFeedbackAdd:get",
              id: 920,
              show: false,
            },
            {
              title: "质量问题审核",
              path: "/lookList",
              name: "carFeedbackList:get",
              id: 1913,
              show: false,
            },
            {
              title: "车架号维护",
              path: "/carVinManage",
              pathChild1: "",
              pathChild2: "",
              name: "carVinMange:get",
              id: 912,
              show: false,
            },
            {
              title: "质量共享平台",
              path: "/typicalProblemList",
              pathChild1: "",
              pathChild2: "",
              name: "carQuestionTypical:get",
              id: 940,
              show: false,
            },
            {
              title: "数据看板",
              path: "/dataStatis/dataBoard",
              pathChild1: "/dataStatis/moreBoard",
              pathChild2: "",
              name: "dataBoard:get",
              id: 923,
              show: false,
            },
            {
              title: "数据报表",
              path: "/dataStatis/dataReport",
              pathChild1: "",
              pathChild2: "",
              name: "dataReport:get",
              id: 924,
              show: false,
            },
            {
              title: "时效报表",
              path: "/timelinessReport",
              pathChild1: "",
              pathChild2: "",
              name: "carQuestionTypical:get",
              id: 939,
              show: false,
            },
          ],
        },
        {
          title: "KD质量反馈管理",
          path: "8",
          icon: "qualityFeedbackManage",
          id: 1300,
          show: false,
          children: [
            {
              title: "质量问题反馈",
              path: "/KDAddFeedback",
              pathChild1: "/KDAddFeedback/detail",
              name: "kdFeedbackAdd:get",
              id: 1301,
              show: false,
            },
            {
              title: "质量问题审核",
              path: "/KDlookList",
              pathChild1: "",
              pathChild2: "",
              name: "kdFeedbackList:get",
              id: 1302,
              show: false,
            },
            {
              title: "质量统计报表",
              path: "/KDprogressStatistics",
              pathChild1: "",
              pathChild2: "",
              name: "kdFeedbackStatistics:get",
              id: 1303,
              show: false,
            },
            {
              title: "问题数量统计",
              path: "/KDcloseStatistics",
              pathChild1: "",
              pathChild2: "",
              name: "kdFeedbackCloseStatistics:get",
              id: 1304,
              show: false,
            },
          ],
        },
        {
          title: "车辆升级管理",
          path: "17",
          icon: "el-icon-truck",
          id: 1400,
          show: false,
          children: [
            {
              title: "车辆升级单管理",
              path: "/vehicleUpgrade/quality",
              pathChild1: "/vehicleUpgrade/quality",
              pathChild2: "/vehicleUpgrade/edit",
              name: "vehicleUpgrade:quality",
              id: 1402,
              show: false,
            },
            {
              title: "车辆升级单分发",
              path: "/vehicleUpgrade/service",
              pathChild1: "/vehicleUpgrade/service",
              name: "vehicleUpgrade:service",
              id: 1403,
              show: false,
            },
            {
              title: "车辆升级单索赔",
              path: "/vehicleUpgrade/serviceClaim",
              pathChild1: "/vehicleUpgrade/serviceClaim",
              pathChild2: "/vehicleUpgrade/claimEdit",
              name: "vehicleUpgrade:serviceClaim",
              id: 1405,
              show: false,
            },
          ],
        },
        {
          title: "消息中心",
          path: "10",
          icon: "el-icon-message",
          id: 910,
          show: false,
          children: [
            {
              title: "消息列表",
              path: "/messageCenter/list",
              pathChild1: "/claimant/preDetail",
              pathChild2: "",
              name: "messageCenterList:get",
              id: 911,
              show: false,
            },
          ],
        },

        {
          title: "客户管理",
          path: "11",
          icon: "el-icon-user",
          id: 891,
          show: false,
          children: [
            {
              title: "客户列表",
              path: "/client",
              pathChild1: "",
              pathChild2: "",
              name: "customerList:get",
              id: 892,
              show: false,
            },
            {
              title: "车主车辆档案",
              path: "/client/car",
              pathChild1: "",
              pathChild2: "",
              name: "ownerCarRecord:get",
              id: 893,
              show: false,
            },
          ],
        },
        {
          title: "系统用户管理",
          path: "12",
          icon: "systemCustomerManage",
          id: 894,
          show: false,
          children: [
            {
              title: "账号管理",
              path: "/user/account",
              pathChild1: "",
              pathChild2: "",
              name: "accountManage:get",
              id: 895,
              show: false,
            },
            {
              title: "角色管理",
              path: "/user/role",
              pathChild1: "",
              pathChild2: "",
              name: "roleManage:get",
              id: 896,
              show: false,
            },
            {
              title: "字典管理",
              path: "/user/dict",
              pathChild1: "",
              pathChild2: "",
              name: "sysCode:get",
              id: 906,
              show: false,
            },
          ],
        },
        {
          title: "流程管理",
          path: "13",
          icon: "processManage",
          id: 1000,
          show: false,
          children: [
            {
              title: "流程定义",
              path: "/flowable/definition",
              pathChild1: "",
              pathChild2: "",
              name: "definition:get",
              id: 1001,
              show: false,
            },
            {
              title: "流程表达式",
              path: "/flowable/expression",
              pathChild1: "",
              pathChild2: "",
              name: "expression:get",
              id: 1003,
              show: false,
            },
            {
              title: "流程表单",
              path: "/flowable/task/form",
              pathChild1: "",
              pathChild2: "",
              name: "form:get",
              id: 1004,
              show: false,
            }
          ],
        },
        {
          title: "任务管理",
          path: "14",
          icon: "taskManage",
          id: 1200,
          show: false,
          children: [
            {
              title: "已发任务",
              path: "/flowable/task/myProcess",
              pathChild1: "",
              pathChild2: "",
              name: "myProcess:get",
              id: 1201,
              show: false,
            },
            {
              title: "待办任务",
              path: "/flowable/task/todo",
              pathChild1: "",
              pathChild2: "",
              name: "todo:get",
              id: 1202,
              show: false,
            },
            {
              title: "已办任务",
              path: "/flowable/task/finished",
              pathChild1: "",
              pathChild2: "",
              name: "finished:get",
              id: 1203,
              show: false,
            }
          ],
        },

        {
          title: "代理商进销存管理",
          path: "15",
          icon: "agentInventory",
          id: 925,
          show: false,
          children: [
            {
              title: "进销存参数设置",
              path: "/purchaseSaleStock/paramsConfig",
              pathChild1: "",
              pathChild2: "",
              name: "jinXiaoCunCanShu:get",
              id: 926,
              show: false,
            },
            {
              title: "新增海外订单",
              path: "/purchaseSaleStock/overseasOrder",
              pathChild1: "",
              pathChild2: "",
              name: "xinZengHaiWaiOrder:get",
              id: 927,
              show: false,
            },
            {
              title: "实销数据查看",
              path: "/purchaseSaleStock/saleData",
              pathChild1: "/purchaseSaleStock/saleData/detail",
              pathChild2: "",
              name: "shiXiaoShuJuChaKan:get",
              id: 928,
              show: false,
            },
          ],
        },
        {
          title: "销售任务收集",
          path: "16",
          icon: "salesTask",
          id: 929,
          show: false,
          children: [
            {
              title: "海外销量查询",
              path: "/saleTaskCollection/historySaleData",
              pathChild1: "",
              pathChild2: "",
              name: "saleTaskSearch:get",
              id: 935,
              show: false,
            },
            {
              title: "信息录入列表",
              path: "/saleTaskCollection/infoListInput",
              pathChild1: "/saleTaskCollection/infoListInput/detail",
              pathChild2: "",
              name: "infoList:get",
              id: 930,
              show: false,
            },
            {
              title: "五看",
              path: "/saleTaskCollection/fiveLook",
              pathChild1: "",
              pathChild2: "",
              name: "fiveSeeList:get",
              id: 933,
              show: false,
            },
            {
              title: "三定",
              path: "/saleTaskCollection/setGoals",
              pathChild1: "",
              pathChild2: "",
              name: "infoList:get",
              id: 934,
              show: false,
            },
            {
              title: "数据统计",
              path: "/saleTaskCollection/statisReport",
              pathChild1: "",
              pathChild2: "",
              name: "saleTaskStatisReport:get",
              id: 936,
              show: false,
            },
          ],
        },
        {
          title: "终端数据管控工具",
          path: "9",
          icon: "el-icon-s-data",
          id: 900,
          show: false,
          children: [
            {
              title: "新增/编辑订单",
              path: "/terminal",
              pathChild1: "/terminal/basic",
              pathChild2: "/terminal/list",
              pathChild3: "/newForm",
              name: "dataManage:get",
              id: 901,
              show: false,
            },
            {
              title: "查阅报表",
              path: "/excel",
              pathChild1: "",
              pathChild2: "",
              name: "dataManage:get",
              id: 902,
              show: false,
            },
          ],
        }
      ],
    };
  },
  watch: {
    '$route.path'(newVal) {
      this.currentMenu = newVal;
    },
    $route() {
      this.currentId = this.$route.meta.id;
      // this.currentMenu = this.$route.path;
      // let _this = this
      // this.$nextTick(() => {
      // Object.keys(_this.$route.query).length==0?_this.query = false:_this.query = _this.$route.query

      //  })
      //  console.log("5465415");
      // this.getBreadcrumb();
    },
  },
  methods: {
    // 获取未读消息数量
    async getMessage() {
      const res = await getNotReadMessageApi();
      if (res.status === "0") {
        this.$store.state.messageCount = res.data.length;
      }
    },
    // 菜单权限处理
    getMenu() {
      if (this.roleList) {
        // 第一轮：匹配权限
        this.menuList.forEach((item) => {
          // 首页和售后数据菜单按需求强制隐藏
          if (item.id === 880 || item.id === 927) {
            item.show = false;
            return;
          }
          if (item.children) {
            item.children.forEach((info) => {
              if (info.children) {
                info.children.forEach((subInfo) => {
                  if (this.roleList.includes(subInfo.name)) {
                    subInfo.show = true;
                    info.show = true;
                    item.show = true;
                  }
                });
              } else {
                if (this.roleList.includes(info.name)) {
                  info.show = true;
                  item.show = true;
                }
              }
            });
          } else if (this.roleList.includes(item.name)) {
            item.show = true;
          }
        });

        // 第二轮：检查并隐藏没有可见子菜单的父级
        this.menuList.forEach((item) => {
          if (item.children) {
            item.children.forEach((info) => {
              if (info.children) {
                const hasVisibleChild = info.children.some(sub => sub.show);
                info.show = hasVisibleChild;
              }
            });
            const hasVisibleChild = item.children.some(info => info.show);
            item.show = hasVisibleChild;
          }
        });
      }
    },
    handlePage(data) {
      if (this.$route.path === data.path) return;
      if (data.path == "") {
        this.$DonMessage.warning("开发中...");
      } else {
        this.currentMenu = data.path;
        setTimeout(() => {
          this.$router.push(data.path);
        }, 100)
      }
    },
    // 点击菜单
    selectMenu(item) {
      this.handlePage(item);
    },
    handleMenu(item) {
      if (this.$route.path === item.path) return;
      // if (item.id === 880 || item.id === 927 || item.id === 941) {
      //   const targetPath = item.id === 880 ? "/index" : item.id === 927 ? "/statis" : "/questionnaire";
      //   if (this.$route.path !== targetPath) {
      //     this.$router.push(targetPath);
      //     this.currentMenu = targetPath;
      //   }
      // }
      if (item.id == 880) {
        this.currentMenu =
          this.currentMenu === "/index" ? this.currentMenu : "";
          setTimeout(() => {
            this.$router.push("/index");
          }, 100);

      }
      if (item.id == 927) {
        this.currentMenu =
          this.currentMenu === "/statis" ? this.currentMenu : "";
          setTimeout(() => {
            this.$router.push("/statis");
          }, 100);

      }
      if (item.id == 941) {
        this.currentMenu =
          this.currentMenu === "/questionnaire" ? this.currentMenu : "";
          setTimeout(() => {
            this.$router.push("/questionnaire");
          }, 100);

      }
      if (this.currentId == item.id) {
        this.showMenu = !this.showMenu;
      } else {
        this.currentId = item.id;
        this.showMenu = true;
      }
    },


    foo() {
      // 取消鼠标监听事件 菜单栏
      this.menuVisible = false;
      document.removeEventListener("click", this.foo); // 关掉监听，
    },
  },
  mounted() {
    this.roleList = Object.values(getSession("menu"));
    this.getMenu();
    this.currentId = this.$route.meta.id;
    this.currentMenu = this.$route.path;
    if (this.roleList.indexOf("messageCenterList:get") !== -1) {
      this.getMessage();
    }
  },
};
</script>
<style>
/* 左侧目录 */
.asideContent {
  height: 100%;
}
aside {
  padding: 0;
}
.el-aside {
  position: relative;
  /* background-color: var(--aside-color); */
  color: rgb(0, 0, 0);
  height: 100%;
  text-align: center;
  overflow: hidden !important;
}
.el-menu-vertical-demo.el-menu {
  height:100%;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.el-menu-item  .el-icon-document:before {
  content: "\e785";
  background: none;
}
/* body */
.el-container.is-vertical {
  width: 100%;
  height: 100%;
}
/* 目录 */
.el-menu {
  border: none !important;
  text-align: left;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 220px;
}
.el-menu > .el-menu-item,
.el-submenu {
  border-top: 1px solid var(--line-color);
}
/* 点击后的目录列表 */
.el-submenu.is-opened > .el-submenu__title {
  color: #000 !important;
  font-weight: bold;
}
/* 目录列表 */
.el-submenu__title,
.el-menu-item {
  color: rgb(0, 0, 0) !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-right: 1px solid var(--line-color) !important;
}
/* .el-aside >  */
.el-menu .el-submenu .el-submenu__title,
.el-menu .custom-menu-item {
  background: var(--subMenu-bgColor) !important;
}
.el-menu .custom-menu-item:hover,
.el-menu .el-submenu .el-submenu__title:hover,
.el-menu .el-menu-item:hover {
  color: #000;
  background-color: var(--line-color) !important;
}
/* 二级 */
.el-menu .el-submenu .el-menu .el-submenu .el-submenu__title,
.el-menu .el-submenu .el-menu .el-menu-item {
  background: var(--twoMenu-bgColor) !important;
}
.el-menu .el-submenu .el-menu .el-menu-item:hover,
.el-menu .el-submenu .el-menu .el-menu-item.is-active:hover,
.el-menu .el-submenu .el-menu .el-menu-item.is-active {
  font-weight: bold;
  color: var(--menuSelect-color) !important;
  background-color: var(--twoMenu-hover) !important;
  border-left: 3px solid var(--theme-color);
}
/* 三级 */
.el-menu .el-submenu .el-menu .el-submenu .el-menu .el-menu-item {
  background: var(--thereMenu-bgColor) !important;
}
.el-menu .el-submenu .el-menu .el-submenu .el-menu .el-menu-item:hover,
.el-menu .el-submenu .el-menu .el-submenu .el-menu .el-menu-item.is-active:hover,
.el-menu .el-submenu .el-menu .el-submenu .el-menu .el-menu-item.is-active {
  font-weight: bold;
  color: var(--menuSelect-color) !important;
  background-color: var(--thereMenu-hover) !important;
  border-left: 3px solid var(--theme-color);
}
.el-menu .el-submenu .el-menu .el-menu-item:hover,
.el-menu .el-submenu .el-menu .el-submenu .el-menu .el-menu-item:hover {
  font-weight: normal;
}
.el-menu-vertical-demo  > .el-menu-item {
  padding-right: 20px;
}
.el-menu--vertical > .el-menu--popup {
  max-height: 100vh;
  overflow-y: inherit;
}
.el-menu--collapse > .el-submenu > .el-submenu__title {
  padding-right: 15px;
}
.el-submenu [class^=el-icon-],
.el-menu-item [class^=el-icon-] {
  width: 22px !important;
  margin-right: 3px;
  font-size: 20px;
  color: #000;
}
/* .el-menu--collapse>.el-menu-item [class^=el-icon-],
.el-menu--collapse>.el-submenu>.el-submenu__title [class^=el-icon-] {
  width: 22px !important;
} */
.el-submenu__icon-arrow {
  font-size: 15px !important;
  right: 8px !important;
}
.el-submenu__title i {
  color: rgb(0, 0, 0) !important;
}
.el-submenu .el-menu-item {
  padding: 0px 12px 0 30px !important;
  color: rgb(0, 0, 0) !important;
  border-left: 3px solid transparent;
  box-sizing: border-box;
}
.el-menu .el-submenu .el-menu .el-submenu .el-submenu__title {
  border-left: 3px solid transparent;
  padding: 0px 20px 0 30px !important;
}
.el-submenu .el-menu.el-menu--inline .el-submenu .el-menu.el-menu--inline .el-menu-item {
  padding: 0px 12px 0 70px !important;
}
.el-submenu .el-menu-item:hover {
  border-left: 3px solid var(--theme-color) !important;
  background: var(--line-color) !important;
}
.el-color-dropdown__btns .el-button--text {
  display: none;
}
/* 设置滚动条的宽度 */
::-webkit-scrollbar {
  width: 5px; /* 垂直滚动条宽度 */
  height: 5px; /* 水平滚动条宽度 */
}

/* 设置滚动条轨道（背景）的颜色 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块（滑动部分）的颜色 */
::-webkit-scrollbar-thumb {
  background: #888; /* 滑块颜色 */
  border-radius: 10px; /* 可选，设置圆角效果 */
}

/* 滑块在悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background: var(--theme-color); /* 悬停时滑块颜色 */
}
/* icon */
.custom-menu-item i::before,
.el-menu-item i::before,
.claimFormManage::before,
.qualityFeedbackManage::before,
.systemCustomerManage::before,
.processManage::before,
.taskManage::before,
.agentInventory::before,
.salesTask::before,
.threeGuaranteesClaim::before,
.claimSettlement::before,
.secondaryClaim::before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  background: "";
  background-size: 100%;
  margin-right: 3px;
  vertical-align: middle;
  margin-top: -3px;
  font-size: 18px;
}
.custom-menu-item i::before {
  margin-top: 2px;
}
.claimFormManage::before {
  background: url("../assets/image/claimFormManage.png") no-repeat;
}
.qualityFeedbackManage::before {
  background:url("../assets/image/qualityFeedbackManage.png") no-repeat;
}
.systemCustomerManage::before {
  background:url("../assets/image/systemCustomerManage.png") no-repeat;
}
.processManage::before {
  background:url("../assets/image/processManage.png") no-repeat;
}
.taskManage::before {
  background:url("../assets/image/taskManage.png") no-repeat;
}
.agentInventory::before {
  background:url("../assets/image/agentInventory.png") no-repeat;
}
.salesTask::before {
  background:url("../assets/image/salesTask.png") no-repeat;
}
.threeGuaranteesClaim::before {
  background:url("../assets/image/threeGuaranteesClaim.png") no-repeat;
}
.claimSettlement::before {
  background:url("../assets/image/claimSettlement.png") no-repeat;
}
.secondaryClaim::before {
  background:url("../assets/image/secondaryClaim.png") no-repeat;
}
</style>
